import countriesIso from 'i18n-iso-countries';

export const findAlpha2ByName = (name: string): string | null => {
  const entry = Object.entries(countriesIso.getNames('en')).find(
    ([alpha2, curName]) => curName?.toLowerCase() === name?.toLowerCase()
  );

  return entry ? entry[0] : null;
};
